<template>
	<div class="color-picker">
		<div
			v-for="variant in variants"
			:key="`color-${variant.id}`"
			:style="{ 'background-color': variant.color_codes }"
			:class="[{ selected: variant.id === currentVariantId }]"
			class="color-circle"
			@click="selectVariant(variant)"
		/>
	</div>
</template>

<script>
export default {
	name: "AccesoryColorPicker",
	props: {
		currentVariantId: {
			type: [Number, String],
			required: true
		},
		variants: {
			type: Array,
			required: true
		},
		isSelected: {
			type: Boolean,
			required: true
		}
	},
	methods: {
		selectVariant({ id }) {
			if (this.isSelected) {
				this.$emit("update-variant", id);
			}

			this.$emit("select-variant", id);
		}
	}
};
</script>

<style lang="scss" scoped>
@import "~@s/_asset-mixers.scss";

.color-picker {
    display: flex;
    justify-content: center;
    padding: 15px 0;

    .color-circle {
        width: 32px;
        height: 32px;
        border: 3px solid $white;
        box-shadow: 0 0 0 1px #dadde0;
        margin-left: 6px;
        border-radius: 100%;
        cursor: pointer;

        &:first-child {
            margin-left: 0;
        }

        &.selected {
            box-shadow: 0 0 0 1px $purple;
        }
    }
}
</style>
